import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { TranslateModule } from '@ngx-translate/core';
import _ from 'lodash';

@Component({
  selector: 'app-chip-selector',
  templateUrl: './chip-selector.component.html',
  styleUrls: ['./chip-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatChipsModule, CommonModule, TranslateModule],
})
export class ChipSelectorComponent implements OnChanges {
  @Input() chips: ChipOption[] = [];
  @Input() multiple: boolean = false;
  @Output() onSelectionChange = new EventEmitter<ChipOption[]>();

  isAllSelected: boolean = false;
  constructor(private cdk: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.modifyChipDataforInitialLoad();
  }

  /**
   * This function will take a look a provided chipOptions and their selection state to modify
   */
  modifyChipDataforInitialLoad(): void {
    if (this.multiple) {
      if (
        this.chips.filter((chip) => !chip.isSelected).length === 0 ||
        this.chips.filter((chip) => chip.isSelected).length ===
          this.chips.length ||
        this.chips.filter((chip) => !chip.isSelected).length ===
          this.chips.length
      )
        this.isAllSelected = true;
      this.chips.map((chip) => (chip.isSelected = false));
      this.cdk.detectChanges();
    }
  }
  /**
   *
   * @param chip : interacted chip
   *
   * inGenerl this isSelected value gets toggled.
   * insace of single selection value will be toglled and rest other selected option will be set to false
   *
   */
  toggleChip(chip: ChipOption): void {
    if (this.isAllSelected) {
      this.isAllSelected = false;
    }

    this.chips.forEach((chipEement: ChipOption) => {
      if (chip.value === chipEement.value) {
        chipEement.isSelected = !chipEement.isSelected;
      } else {
        if (!this.multiple) {
          chipEement.isSelected = false;
        }
      }
    });
    const numberOfSelectedChip = this.chips.filter(
      (chip) => chip.isSelected,
    ).length;
    if (
      this.multiple &&
      (numberOfSelectedChip === 0 || numberOfSelectedChip === this.chips.length)
    ) {
      this.selectAllChips();
    } else this.emitChanges(this.chips);
  }

  selectAllChips(): void {
    this.chips.map((chip) => (chip.isSelected = false));
    this.isAllSelected = true;

    const allSelectedChips = _.cloneDeep(this.chips);
    allSelectedChips.map((chip) => {
      chip.isSelected = true;
    });
    this.cdk.detectChanges();

    this.emitChanges(allSelectedChips);
  }
  isCheapSelected(chip: ChipOption): boolean {
    return this.chips.filter((x) => x.value === chip.value)[0].isSelected;
  }
  emitChanges(slectedChips: ChipOption[]): void {
    this.onSelectionChange.emit(slectedChips);
    this.cdk.detectChanges();
  }
}

export interface ChipOption {
  displayName: string;
  value: string;
  isSelected: boolean;
}
